import { render, staticRenderFns } from "./InstructorsList.vue?vue&type=template&id=07b76bc2&scoped=true&"
import script from "./InstructorsList.vue?vue&type=script&lang=js&"
export * from "./InstructorsList.vue?vue&type=script&lang=js&"
import style0 from "./InstructorsList.vue?vue&type=style&index=0&id=07b76bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b76bc2",
  null
  
)

export default component.exports